import classNames from 'classnames';
import React, { useRef } from 'react';
import { Button } from 'src/common/button';
import { EditorConfirmPanel } from 'src/editor/confirm-panel';
import { functionNoop } from 'src/utils/function/noop';

const ActionBar = ({
  selectedCount,
  onClearSelection,
  handleConfirmDelete,
  containerClasses,
  confirmPanelCopy,
}: {
  selectedCount: number;
  onClearSelection: () => void;
  handleConfirmDelete: () => void;
  containerClasses?: string;
  confirmPanelCopy?: string;
}) => {
  const deleteConfirmPanelOpenRef = useRef(functionNoop);
  const deleteConfirmPanelCloseRef = useRef(functionNoop);
  const onDeleteDenied = () => {
    deleteConfirmPanelCloseRef.current();
  };
  if (selectedCount === 0) return null;
  return (
    <div
      className={classNames(
        'flex w-full items-center justify-between bg-bedrock-gray-medium p-4 rounded-md',
        containerClasses
      )}
    >
      <p className='text-bedrock-p-small'>
        <span className='text-bedrock-p-strong'>{selectedCount}</span> {selectedCount > 1 ? 'items' : 'item'} selected
      </p>
      <div className='flex items-center'>
        <Button size='regular' variant='secondary' onClick={onClearSelection} className='ml-4' label='Clear' />
        <EditorConfirmPanel
          copy={confirmPanelCopy ?? `Are you sure you want to delete ${selectedCount} selected item(s)?`}
          confirmCopy='Yes, delete'
          denyCopy='No, keep'
          onConfirm={handleConfirmDelete}
          onDeny={onDeleteDenied}
          openRef={deleteConfirmPanelOpenRef}
          closeRef={deleteConfirmPanelCloseRef}
          placement='bottom-end'
          openAfterMount={false}
          hasBackButton={false}
          renderOrigin={() => <Button size='small' variant='primary' className='ml-2' label='Delete Selected' />}
        />
      </div>
    </div>
  );
};

export default ActionBar;
